'use client';

import { useCheckout } from '../checkout-context';
import PlanSelector from '../plan-selector';

export default function PlanStep() {
  const { state, selectPlan } = useCheckout();

  return (
    <div>
      <h2 className="text-3xl font-bold text-center mb-6 font-merriweather">Choose your plan</h2>
      <PlanSelector selectedTier={state.selectedTier} onSelect={selectPlan} />
    </div>
  );
}
